<template>
  <textarea
    class="BudoTextarea"
    placeholder="在这里输入标题"
    v-model="valueData"
    @input="onInput"
    rows="1"></textarea>
</template>

<script>
export default {
    name : 'BudoTextarea',

    props : ['value'],

    data() {
        return {
            valueData : null
        };
    },

    mounted() {
        this.onValueChange();

        $(document).on('keyup', '.BudoTextarea', this._textareaAutoHeight);
        $(document).on('keydown', '.BudoTextarea', this._textareaAutoHeight);

        $(".BudoTextarea").each(this._textareaAutoHeight);
    },

    watch : {
        value() {
            this.onValueChange();
        }
    },

    methods : {
        onInput() {
            this.$emit('input', this.valueData);
        },

        onValueChange() {
            this.valueData = this.value;
        }
    }
}
</script>

<style scoped>
    .BudoTextarea {
        font-size:16px;
        width:100%;
        border: 1px solid #dcdfe6;
        height: 36px;
        line-height: 30px;
        padding-left: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/BudoTextarea.vue